import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useCallback, useMemo } from 'react';
import { request } from '@atlaskit/linking-common';
import { InvokeError } from '@atlaskit/linking-types/smart-link-actions';
import { useResolverUrl } from '../use-resolver-url';

/**
 * useSmartLinkClientExtension
 *
 * This hook extends the usage of @atlaskit/link-provider CardClient
 * for smart links.
 *
 * @param cardClient
 */
export var useSmartLinkClientExtension = function useSmartLinkClientExtension(cardClient) {
  var resolverUrl = useResolverUrl(cardClient);
  var invoke = useCallback( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(data) {
      var errorBody;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return request('post', "".concat(resolverUrl, "/invoke"), data, undefined, [200, 201, 202, 203, 204]);
          case 3:
            return _context.abrupt("return", _context.sent);
          case 6:
            _context.prev = 6;
            _context.t0 = _context["catch"](0);
            if (!(_context.t0 && _context.t0.json && typeof _context.t0.json === 'function')) {
              _context.next = 14;
              break;
            }
            _context.next = 11;
            return _context.t0.json();
          case 11:
            errorBody = _context.sent;
            if (!errorBody) {
              _context.next = 14;
              break;
            }
            throw new InvokeError(errorBody === null || errorBody === void 0 ? void 0 : errorBody.error.message, errorBody === null || errorBody === void 0 ? void 0 : errorBody.error.status);
          case 14:
            throw _context.t0;
          case 15:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 6]]);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [resolverUrl]);
  return useMemo(function () {
    return {
      invoke: invoke
    };
  }, [invoke]);
};